import { render } from "./orderType.vue?vue&type=template&id=145a37c6&scoped=true"
import script from "./orderType.vue?vue&type=script&lang=js"
export * from "./orderType.vue?vue&type=script&lang=js"

import "./orderType.vue?vue&type=style&index=0&id=145a37c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-145a37c6"]])

export default __exports__